import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var ClockFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 .42c-12.154 0-22 9.846-22 22s9.846 22 22 22 22-9.846 22-22-9.846-22-22-22Zm-.917 11.697c0-.509.409-.917.917-.917s.917.408.917.917v9.85c0 .244.096.477.268.648l8.995 9.008a.906.906 0 0 1 .006 1.29l-.005.005a.915.915 0 0 1-1.295 0l-9.533-9.533a.915.915 0 0 1-.27-.647V12.117Z"
  }));
});
ClockFill.displayName = 'ClockFill';
ClockFill.defaultProps = {
  'aria-label': 'ClockFill'
};
export default ClockFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/ClockFill.js
// module id = 3127
// module chunks = 11